import { baseSpacing } from '../../consts';

export const getSpacingValueFromNumber = (factor: number, addPx = false) => {
  const baseValue = factor * baseSpacing;

  return addPx ? `${baseValue}px` : baseValue;
};
